import Button from '@restart/ui/esm/Button'
import React, { useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import { toast } from 'react-toastify';
import DashboardMainTitle from '../../../dashboardTitle/DashboardMainTitle';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNewCategory } from '../../../../redux/action/category/createNewCategory';
import SimpleReactValidator from 'simple-react-validator';
import { useTranslation } from 'react-i18next';

const NewCategory = (props) => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const [newCategory , setNewCategory] = useState(false)
    const [name , setName] = useState('')
    const dispatch = useDispatch()
    const category = useSelector(state => state.category)
    const {t} = useTranslation();

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    const handleCreateNewCategory = () => {
        setNewCategory(true)
        window.scrollTo(0, 400)
    }

    const handleCreate = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            setBtnLoading(false)
            setNewCategory(false)
            window.scrollTo(0, 0)
            props.update()
            dispatch(fetchNewCategory({name: name}))
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    return (
        <>
            <div className="col-12 create_btn my-5 d-flex justify-content-end">
                <button className="btn btn-success" onClick={handleCreateNewCategory}> {t("create category")} <i className="fa fa-plus"></i></button>
            </div>
            {newCategory ?
                <div className="form-container">
                    <DashboardMainTitle> {t("create category")} </DashboardMainTitle>

                    <div className="col-md-5">
                        <Form className="mt-5" onSubmit={handleCreate}>
                            <Form.Group className="mb-3" controlId="formBasicText">
                                <Form.Label>{t("title")} : </Form.Label>
                                <Form.Control type="text" name="name" value={name} onChange={e => setName(e.target.value)} />
                                <span className='validator_error'>{validator.current.message('name', name, 'required')}</span>
                            </Form.Group>
                            <Button variant="primary" type="submit" className="btn green-btn" disabled={btnLoading ? true : false}>
                                {t("create")} 
                            </Button>
                        </Form>
                    </div>
                </div>
            : ""
            }
        </>
    )
}

export default NewCategory
